"use client";

import { useEffect, useRef, useState } from "react";
import { usePathname } from "next/navigation";

const VersionChecker = () => {
  const pathname = usePathname();
  const pathnameRef = useRef(pathname);
  const [isDevMode] = useState(process.env.NODE_ENV === "development");

  // Keep ref current so interval callbacks read the latest pathname
  useEffect(() => {
    pathnameRef.current = pathname;
  }, [pathname]);

  // Check interval - 30 seconds in dev, 5 minutes in production
  const CHECK_INTERVAL = isDevMode ? 30000 : 300000;

  const checkVersion = async () => {
    if (pathnameRef.current !== "/") return;

    try {
      const response = await fetch("/api/version");
      const { version: fetchedLatestVersion } = await response.json();
      const storedVersion = localStorage.getItem("app_version");

      if (!storedVersion) {
        localStorage.setItem("app_version", fetchedLatestVersion);
      } else if (storedVersion !== fetchedLatestVersion) {
        localStorage.setItem("app_version", fetchedLatestVersion);
        window.location.reload();
      }
    } catch (error) {}
  };

  useEffect(() => {
    checkVersion();

    const interval = setInterval(checkVersion, CHECK_INTERVAL);

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkVersion();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [CHECK_INTERVAL]);

  return null;
};

export default VersionChecker;
